"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cb;

var _underscore = _interopRequireDefault(require("./underscore.js"));

var _baseIteratee = _interopRequireDefault(require("./_baseIteratee.js"));

var _iteratee = _interopRequireDefault(require("./iteratee.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The function we call internally to generate a callback. It invokes
// `_.iteratee` if overridden, otherwise `baseIteratee`.
function cb(value, context, argCount) {
  if (_underscore.default.iteratee !== _iteratee.default) return _underscore.default.iteratee(value, context);
  return (0, _baseIteratee.default)(value, context, argCount);
}